var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-wrapper"},_vm._l((_vm.q_ids),function(id,key){return _c('Charts',{key:key,attrs:{"question_id":id,"stats":_vm.stats.filter(function (e) { return e.question_id === id; })}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }